import { createVanIconComponent } from "./van"

const Sign = createVanIconComponent("sign")
export default Sign
